var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('img',{attrs:{"src":require("@/assets/platform-tc/1.png")}})]),_c('div',[_c('img',{attrs:{"src":require("@/assets/platform-tc/3.png")}})])])
}]

export { render, staticRenderFns }